/**
 * Created by mac on 2/25/20
 */

const TileTable = function () {
    cleverapps.EventEmitter.call(this);

    this.canvas = this.getCanvas();

    this.getView = function () {};

    this.cards = [];
};

TileTable.prototype = Object.create(cleverapps.EventEmitter.prototype);
TileTable.prototype.constructor = TileTable;

TileTable.prototype.getCanvas = function () {
    if (this.orientation === TileTable.ORIENTATION_HORIZONTAL) {
        return {
            width: 1600,
            height: 800
        };
    }

    return {
        width: 800,
        height: 1000
    };
};

TileTable.REPAINT = function (cards) {
    const isNextCard = function (a, b) {
        if (!cards[a].overlaps(cards[b])) {
            return false;
        }
        for (let k = a + 1; k < b; k++) {
            if (cards[k].overlaps(cards[b]) && cards[a].overlaps(cards[k])) {
                return false;
            }
        }
        return true;
    };

    for (let i = 0; i < cards.length; i++) {
        if (cards[i].canRepaint) {
            const badValues = {};
            for (let j = i - 1; j >= 0; j--) {
                if (isNextCard(j, i)) {
                    badValues[cards[j].value] = true;
                }
            }

            if (badValues[cards[i].value]) {
                const varriants = [];
                for (let j = i + 1; j < cards.length; j++) {
                    if (cards[j].canRepaint && !badValues[cards[j].value]) {
                        varriants.push(j);
                    }
                }
                if (varriants.length > 0) {
                    j = PseudoRandom.GET().choose(varriants);
                    const tmp = cards[i].value;
                    cards[i].value = cards[j].value;
                    cards[j].value = tmp;
                }
            }
        }
    }
};

TileTable.RESORT = function (cards) {
    let i = cards.length - 2;
    while (i >= 0) {
        if (i + 1 <= cards.length - 1 && !cards[i + 1].overlaps(cards[i])) {
            if (cards[i + 1].y > cards[i].y || (cards[i + 1].y === cards[i].y && cards[i + 1].x < cards[i].x)) {
                const tmp = cards[i + 1];
                cards[i + 1] = cards[i];
                cards[i] = tmp;
                i++;
                continue;
            }
        }
        i--;
    }
};

TileTable.prototype.setCards = function (cards, magic, maxValue) {
    magic = magic || [];
    this.streakCard = undefined;

    cards = cards.concat(magic.map((data) => Object.assign(data, {
        magic: true
    })));

    cards = cards.map((card) => card).flat();

    Game.currentGame.generator.reset(cards, maxValue);

    cards = cards.map((data) => TileFactory.Create(data));

    TileTable.RESORT(cards);
    TileTable.REPAINT(cards);

    this.cards = cards;

    cards.forEach(function (card) {
        card.setOwner(this);
    }, this);

    this.stacksPosition = undefined;

    this.trigger("resetCards");
};

TileTable.prototype.listMissed = function () {
    return this.cards.filter((card) => card.canPlay());
};

TileTable.prototype.getStacksPosition = function () {
    if (this.stacksPosition === undefined) {
        this.stacksPosition = cc.p(cc.rectGetCenter(this.rect).x, this.rect.y - Card.HEIGHT);
    }

    return this.stacksPosition;
};

TileTable.prototype.push3CardsToStack = function (cards) {
    const stacks = [-1, 0, 1].map(function (x) {
        const position = this.getStacksPosition();

        return cc.p(position.x + x * Card.WIDTH, position.y);
    }, this);

    cards.forEach(function (card, index) {
        const stack = stacks[index];

        card.setPosition(stack);

        for (let l = 0; l < 5; l++) {
            const occupied = this.cards.find((existingCard) => existingCard.samePlace(card));

            if (!occupied) {
                break;
            }

            card.y -= Card.GRID_XY;
        }
        this.addCard(card);
    }, this);

    let rect = this.rect;
    cards.forEach((card) => {
        rect = cc.rectUnion(rect, cc.rect(card.x - Card.WIDTH / 2, card.y - Card.HEIGHT / 2, Card.WIDTH, Card.HEIGHT));
    });

    this.setRect(rect);
}; 

TileTable.prototype.animateUpdateSize = function () {
    this.trigger("animatedChangeSize");
};

TileTable.prototype.onResize = function () {
    this.trigger("changeSize");
};

TileTable.prototype.calcRect = function (cards) {
    cards = cards || this.cards;
    if (cards.length === 0) {
        return cc.rect(0, 0, 0, 0);
    }
    let rect = cc.rect(cards[0].x - Card.WIDTH / 2, cards[0].y - Card.HEIGHT / 2, Card.WIDTH, Card.HEIGHT);

    cards.forEach((card) => {
        const cardWidth = Card.WIDTH * card.getScale();
        const cardHeight = Card.HEIGHT * card.getScale();
        const rotation = card.r * Math.PI / 180;
        const rotatedWidth = Math.abs(cardWidth * Math.cos(rotation) + Math.abs(cardHeight * Math.sin(rotation)));
        const rotatedHeight = Math.abs(cardHeight * Math.cos(rotation)) + Math.abs(cardWidth * Math.sin(rotation));
        rect = cc.rectUnion(rect, cc.rect(card.x - rotatedWidth / 2, card.y - rotatedHeight / 2, rotatedWidth, rotatedHeight));
    });

    return rect;
};

TileTable.prototype.setRect = function (rect) {
    this.rect = rect || this.calcRect();
};

TileTable.prototype.getCardPosition = function (card) {
    return {
        parent: this.getView(),
        point: CardView.convertToViewPosition(card)
    };
};

TileTable.prototype.getInfo = function () {
    const cards = this.cards.filter((card) => !card.magic).map((card) => card.toJSON());

    const magic = this.cards.filter((card) => card.magic).map((card) => card.toJSON());

    return {
        rect: this.rect,
        cards,
        magic
    };
};

TileTable.prototype.isEmpty = function () {
    return this.cards.length === 0 || this.cards.length === 1 && this.cards[0].feature === "streak";
};

TileTable.prototype.cardClicked = function (card) {
    if (!card.isOpen()) {
        return false;
    }

    if (!Game.currentGame.open.canPlay(card)) {
        card.trigger("wrongMove");
        return false;
    }

    this.startPlayCard(card);
    return true;
};

TileTable.prototype.startPlayCard = function (card) {
    cleverapps.effects.fire("tile3.tile.play");

    card.index = card.getZ();
    this.removeCard(card);
    card.trigger("removeFromTable");
    card.trigger("hideTutorial");
    Game.currentGame.playCard(card);
};

TileTable.prototype.removeCard = function (card) {
    const index = this.cards.indexOf(card);
    this.cards.splice(index, 1);
};

TileTable.prototype.getCardOrder = function (card) {
    return this.cards.indexOf(card);
};

TileTable.prototype.shuffle = function () {
    const cards = PseudoRandom.GET().shuffle(this.cards.map((card, index) => ({
        index,
        position: cc.p(card.x, card.y),
        magic: card.magic
    })));

    const newCards = new Array(cards.length);
    cards.forEach(function (card, index) {
        newCards[card.index] = this.cards[index];
        newCards[card.index].setPosition(card.position);
        newCards[card.index].magic = card.magic;
    }, this);

    this.cards = newCards;

    this.cards.forEach((card) => {
        card.open();

        for (let i = 0; i < card.components.length; i++) {
            card.components[i].handleFlip(card.isOpen(), { shuffle: true });
        }

        card.trigger("flip");
    }, this);

    this.trigger("shuffle");

    Game.currentGame.counter.setTimeout(() => {}, Card.SHUFFLE_TIMEOUT * 1000);
};

TileTable.prototype.findCardsToBlow = function () {
    const tilesByValue = {};
    const openedByValue = {};

    this.cards.forEach((card, index) => {
        if (!tilesByValue[card.value]) {
            tilesByValue[card.value] = [];
            openedByValue[card.value] = 0;
        }
        if (card.opened || !this.cardOverlapping(index)) {
            openedByValue[card.value]++;
            tilesByValue[card.value].unshift(card);
        } else {
            tilesByValue[card.value].push(card);
        }
    });

    const openedCards = [];
    for (const value in openedByValue) {
        openedCards.push({ amount: openedByValue[value], value });
    }
    openedCards.sort((value1, value2) => value2.amount - value1.amount);

    for (let i = 0; i < openedCards.length; i++) {
        if (tilesByValue[openedCards[i].value].length >= 3) {
            return tilesByValue[openedCards[i].value].slice(0, 3);
        }
    }
};

TileTable.prototype.blowCards = function (countOfTriads) {
    cleverapps.focusManager.distract({
        focus: "blowCards",
        keepControls: true,
        action: function (f) {
            const cardsToBlow = [];
            for (let index = 0; index < countOfTriads; index++) {
                const cards = this.findCardsToBlow();
                if (cards) {
                    cards.forEach((card) => {
                        Game.currentGame.table.removeCard(card);
                        card.trigger("removeFromTable");
                        card.trigger("hideTutorial");
                    });
                    cardsToBlow.push(cards);
                }
            }

            this.trigger("blowCards", cardsToBlow.flat(), () => {
                f();
                Game.currentGame.counter.trigger();
            });
        }.bind(this)
    });
};

TileTable.ListMagicCards = function (screen) {
    if (cleverapps.environment.isEditorScene()) {
        const orientation = Game.currentGame.table.getOrientation();
        return (orientation === TileTable.ORIENTATION_HORIZONTAL ? screen.magicH : screen.magicV) || [];
    }

    const orientation = TileTable.detectOrientation();
    return orientation === TileTable.ORIENTATION_VERTICAL && screen.magicV.length > 0 ? screen.magicV : screen.magicH;
};

TileTable.prototype.getAmountOfCards = function () {
    return this.cards.length;
};

TileTable.prototype.addCard = function (card, position) {
    position = position || this.cards.length;
    this.cards.splice(position, 0, card);
    card.setOwner(this);

    this.updateCardZOrder();
};

TileTable.prototype.hasCard = function (card) {
    return this.cards.indexOf(card) !== -1;
};

TileTable.prototype.insertBeforeCard = function (existingCard, newCard) {
    const index = this.cards.indexOf(existingCard);
    this.cards.splice(index, 0, newCard);

    this.updateCardZOrder();
};

TileTable.prototype.replaceCard = function (oldCard, newCard) {
    const index = this.cards.indexOf(oldCard);
    this.cards[index] = newCard;
};

TileTable.prototype.cardOverlapping = function (cardIndex, card) {
    for (let i = cardIndex + 1; i < this.cards.length; i++) {
        if ((card || this.cards[cardIndex]).overlaps(this.cards[i])) {
            return true;
        }
    }

    return false;
};

TileTable.prototype.showCards = function (f, silent) {
    const waiter = cleverapps.wait(this.cards.length, () => {
        if (cleverapps.config.type === "tile3" && !silent) {
            for (let i = 0; i < this.cards.length; i++) {
                if (!this.shouldFlipCard(i)) {
                    this.cards[i].listMarks().forEach((mark) => {
                        mark.show();
                    });
                }
            }
        }

        f();
    });

    const delays = this.calcShowUpDelays(silent);

    this.cards.forEach((card, index) => {
        if (silent) {
            card.animateShowUp(waiter, silent);
            return;
        }

        if (cleverapps.config.type === "tile3") {
            card.listMarks().forEach((mark) => {
                mark.hide();
            });
        }

        Game.currentGame.counter.setTimeout(() => {
            card.animateShowUp(waiter);
        }, delays[index]);
    });
};

TileTable.prototype.flipNormalize = function (f, silent) {
    const cards = [];

    for (let i = this.cards.length - 1; i >= 0; i--) {
        if (this.shouldFlipCard(i)) {
            cards.push(this.cards[i]);
        }
    }

    if (cleverapps.config.type === "solitaire" && !cleverapps.environment.isAdministratorScene() && !cleverapps.environment.isEditorScene()) {
        this.avoidOpenCardsWithSamesRanks(cards);
    }

    if (!f) {
        cards.forEach((card) => {
            card.flip(cleverapps.environment.isEditorScene() || cleverapps.environment.isAdministratorScene());
        });
        return;
    }

    cards.sort((a, b) => {
        const rowA = Math.round(a.y / 200);
        const rowB = Math.round(b.y / 200);

        if (rowA !== rowB) {
            return rowB - rowA;
        }

        return a.x - b.x;
    });

    if (silent) {
        cards.forEach((card) => {
            card.flip(silent);
        });
        f();
    } else {
        this.sound = cleverapps.effects.fire("tile3.blackout");
        const cardFlipTime = cleverapps.config.type === "tile3" ? 1000 / cards.length : 50;

        let timeouts = [];
        for (let j = 0; j < cards.length; j++) {
            timeouts.push(j * cardFlipTime);
        }
        if (cleverapps.config.type === "solitaire") {
            timeouts = PseudoRandom.GET().shuffle(timeouts);
        }

        const waiter = cleverapps.wait(cards.length, () => {
            cleverapps.audio.stopSound(this.sound);
            cleverapps.effects.fire("tile3.card.appear");
            f();
        });
        cards.forEach((card, i) => {
            setTimeout(() => {
                card.flip();
                waiter();
            }, timeouts[i]);
        });
    }
};

TileTable.prototype.avoidOpenCardsWithSamesRanks = function (flippingCards) {
    const openCards = this.cards.filter((card) => card.isOpen());

    const existedRanks = {};
    openCards.forEach((card) => {
        existedRanks[card.getRank()] = true;
    });

    const newOpen = flippingCards.filter((card) => !card.isOpen() && !card.wasShown && !card.feature);
    let cardsToReplace = this.cards.filter((card) => !card.isOpen() && !card.wasShown && !existedRanks[card.getRank()] && !card.feature && !newOpen.includes(card));

    newOpen.forEach((card) => {
        if (existedRanks[card.getRank()]) {
            if (cardsToReplace.length) {
                const value = cardsToReplace[0].value;
                cardsToReplace[0].value = card.value;
                card.value = value;
            } else {
                for (let i = 0; i < 30; i++) {
                    card.setRandomValue();
                    if (!existedRanks[card.getRank()]) {
                        break;
                    }
                }
            }
            existedRanks[card.getRank()] = true;
            cardsToReplace = cardsToReplace.filter((card) => !existedRanks[card.getRank()]);
        }
    });
};

TileTable.prototype.shouldFlipCard = function (cardInd) {
    const card = this.cards[cardInd];
    const isOverlapping = this.cardOverlapping(cardInd);

    return !card.isOpen() && !isOverlapping || card.isOpen() && isOverlapping;
};

TileTable.prototype.returnCard = function (card, index) {
    card.onReturnToScreen(index);
    card.registerAnimationTime(Card.RETURN_TIMEOUT);
    Game.currentGame.counter.trigger();
};

TileTable.prototype.listOpen = function () {
    return this.cards.filter((card) => card.isOpen());
};

TileTable.prototype.calcShowUpDelays = function () {
    let deep = 0, changed = true;
    while (changed) {
        changed = false;
        for (let i = 0; i < this.cards.length; i++) {
            if (this.cards[i].deep === undefined) {
                let intersect = false;
                for (let j = i + 1; j < this.cards.length; j++) {
                    if (this.cards[i].overlaps(this.cards[j]) && this.cards[j].deep === undefined) {
                        intersect = true;
                        break;
                    }
                }
                if (!intersect) {
                    this.cards[i].deep = deep;
                    changed = true;
                }
            }
        }
        deep--;
    }

    this.cards.sort((a, b) => {
        if (a.deep !== b.deep) {
            return a.deep - b.deep;
        }
        return a.x * 10 + a.y - b.x * 10 - b.y;
    });

    let currDeep;
    let offset = 0;
    let res = [];
    const delays = [];
    this.cards.forEach((card, index) => {
        if (currDeep !== card.deep) {
            if (currDeep !== undefined) {
                offset += 50;
            }

            currDeep = card.deep;

            delays.push([]);
        }

        delays[delays.length - 1].push(index * 50 + offset);
    }, this);

    delays.forEach((group) => {
        const first = group.splice(0, group.length / 2);
        res = res.concat(first.concat(PseudoRandom.GET().shuffle(group)));
    });

    this.updateCardZOrder();

    return res;
};

TileTable.prototype.updateFeatures = function (type) {
    this.cards.forEach((card) => {
        card.updateFeature(type);
    });
};

TileTable.prototype.clear = function () {
    this.cards.forEach((card) => {
        card.clear();
    });

    this.cards = [];
};

TileTable.prototype.updateCardZOrder = function () {
    for (let i = 0; i < this.cards.length; i++) {
        this.cards[i].trigger("updateZ");
    }
};

TileTable.DIRECTIONS = [{
    x: 0, y: -1
}, {
    x: -1, y: 0
}, {
    x: 0, y: 1
}, {
    x: 1, y: 0
}];

TileTable.MAX_SCALE = 1.7;

TileTable.ORIENTATION_HORIZONTAL = 0;
TileTable.ORIENTATION_VERTICAL = 1;

TileTable.detectOrientation = function () {
    if (cleverapps.config.orientation === "horizontal") {
        return TileTable.ORIENTATION_HORIZONTAL;
    }
    if (cleverapps.config.orientation === "vertical") {
        return TileTable.ORIENTATION_VERTICAL;
    }
    return cleverapps.resolution && cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL
        ? TileTable.ORIENTATION_HORIZONTAL : TileTable.ORIENTATION_VERTICAL;
};